import { CloseOutlined } from "@ant-design/icons";
import { Button, Col, Form, FormInstance, Input, Modal, Row, Select, SelectProps, Tag, Typography } from "antd";
import { useEffect, useState } from "react";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { SettingEqTypeFugitive } from "src/entity/settings/fugitive";
import { componentPalette } from "src/theme/component-palette";
import { generateErrorMessage } from "src/utils/error-message";

const { Text } = Typography;
type TagRender = SelectProps["tagRender"];

const FugitiveEqTypeModal = (props: {
  form: FormInstance;
  open: boolean;
  loading: boolean;
  mode: "insert" | "update";
  isDuplicate: boolean;
  onDuplicateChange: (isDup: boolean) => void;
  onCloseModal: () => void;
  onSave: (mode: "insert" | "update", data: SettingEqTypeFugitive) => void;
}) => {
  const { form, loading, open, mode, isDuplicate, onCloseModal, onSave, onDuplicateChange } = props;
  console.log({ form: form.getFieldsValue() });
  const [errorDuplicate, setErrorDuplicate] = useState<string | null>(null);

  const [cnt, setCnt] = useState(0);

  const handleSave = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      onSave(mode, values);
    } catch (error) {
      console.error(error);
    }
  };

  const onChangeForm = (changeValue: any) => {
    if (["equipmentType", "symbol"].some((key) => changeValue[key])) {
      onDuplicateChange(false);
    }
  };

  useEffect(() => {
    const errorText = isDuplicate ? "Equipment Type or Symbol already exists in the system." : "";
    setErrorDuplicate(errorText);
    form.setFields(
      ["equipmentType", "symbol"].map((field) => ({
        name: field,
        errors: isDuplicate ? [""] : [],
      })),
    );
  }, [isDuplicate]);

  const tagRender: TagRender = (props) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        color={"#91DBC7"}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        closeIcon={<CloseOutlined style={{ color: componentPalette.black }} />}
        style={{ marginInlineEnd: 4, marginBottom: 1.5, marginTop: 1.5 }}
      >
        <span style={{ color: componentPalette.black }}>{label}</span>
      </Tag>
    );
  };

  return (
    <div>
      <Modal
        centered
        maskClosable={false}
        open={open}
        onCancel={onCloseModal}
        width={700}
        title={<ModalTitle title="Equipment Type" />}
        footer={
          <Row className="w-full border-t" justify={"end"}>
            <Button className="mt-4" key="submit" type="primary" loading={loading} onClick={handleSave}>
              Save
            </Button>
          </Row>
        }
      >
        {errorDuplicate && (
          <>
            <Row className="w-full" justify={"center"}>
              <Text type="danger">{errorDuplicate}</Text>
            </Row>
          </>
        )}
        <Form size="middle" layout="vertical" autoComplete="off" form={form} requiredMark={false} onValuesChange={onChangeForm}>
          <Row gutter={[16, 0]}>
            <Col xs={24}>
              <Form.Item
                label={<FormLabel label={"Equipment Type"} required />}
                name={"equipmentTypeList"}
                required
                rules={[
                  {
                    required: true,
                    message: generateErrorMessage("Equipment Type"),
                  },
                ]}
              >
                <Select
                  mode="tags"
                  className="w-full"
                  onChange={async () => {
                    await new Promise((resolve) => setTimeout(resolve, 100));
                    setCnt(cnt + 1);
                  }}
                  tagRender={tagRender}
                  options={[]}
                />
                {/* <Input /> */}
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item
                label={<FormLabel label={"Symbol"} required />}
                name="symbol"
                rules={[
                  {
                    required: true,
                    message: generateErrorMessage("Symbol"),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default FugitiveEqTypeModal;
